import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';

import {
	currentUserHasAssetAttributeAccess,
	legacyPermissionsEnabled,
} from '@netx/core-permissions-next/enablers';

export const canQuickEdit = () => {
	if (legacyPermissionsEnabled())
		return currentUserMeetsUserLevel(UserLevel.PRODUCER);

	return currentUserHasAssetAttributeAccess();
};
